import { render, staticRenderFns } from "./View15.vue?vue&type=template&id=3d64b34e&scoped=true&"
import script from "./View15.vue?vue&type=script&lang=js&"
export * from "./View15.vue?vue&type=script&lang=js&"
import style0 from "./View15.vue?vue&type=style&index=0&id=3d64b34e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64b34e",
  null
  
)

export default component.exports